import "./SwipeableModals.scss";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import moment from "moment";

// Main Component
const SwipeableModals = ({ open, onClose, onOpen, currentView, rowData }) => {
  console.log("Modal data:", rowData);

  const renderUserRatesView = () => (
    <div className="user-modal">
      <p className="user-modal-p">عرض التقييم</p>
      <div className="shop">
        <p className="title">تعليق العميل</p>
        <p className="rate-text">{rowData?.comment}</p>
      </div>
    </div>
  );

  const renderLogDetailsView = () => (
    <div className="user-modal">
      <p className="user-modal-p">تفاصيل سجل الحضور والانصراف</p>

      <div className="shop">
        <p className="title">بيانات الفني</p>
        <p className="rate-text">{rowData?.technician?.name}</p>
      </div>

      <div className="shop">
        <p className="title">وقت الحضور</p>
        <p className="rate-text">
          {rowData?.loginTime &&
            moment(rowData?.loginTime).format("YYYY/MM/DD - hh:mm")}{" "}
          {moment(rowData?.loginTime).hour() < 12 ? "صباحاً" : "مساءً"}
          <br />
          تم التسجيل بواسطة: {rowData?.loginChangedBy?.name} (
          {rowData?.loginChangedByType === "Technician"
            ? "الفني نفسه"
            : "الإدارة"}
          )
        </p>
      </div>

      {rowData?.logoutTime && (
        <div className="shop">
          <p className="title">وقت الانصراف</p>
          <p className="rate-text">
            {moment(rowData?.logoutTime).format("YYYY/MM/DD - hh:mm")}{" "}
            {moment(rowData?.logoutTime).hour() < 12 ? "صباحاً" : "مساءً"}
            <br />
            {rowData?.logoutChangedBy && (
              <>
                تم التسجيل بواسطة: {rowData?.logoutChangedBy?.name} (
                {rowData?.logoutChangedByType === "Technician"
                  ? "الفني نفسه"
                  : "الإدارة"}
                )
              </>
            )}
          </p>
        </div>
      )}

      <div className="shop">
        <p className="title">إجمالي ساعات العمل</p>
        <p className="rate-text">
          {rowData?.totalHoursWorked?.toFixed(2)} ساعة
        </p>
      </div>
    </div>
  );

  const renderDefaultView = () => <div></div>;

  const views = {
    userRates: renderUserRatesView,
    logDetails: renderLogDetailsView,
  };

  return (
    <SwipeableDrawer
      anchor="left"
      open={open}
      onClose={onClose}
      onOpen={onOpen}
      sx={{ zIndex: "1202" }}
      disableScrollLock
    >
      {(views[currentView] || renderDefaultView)()}
    </SwipeableDrawer>
  );
};

export default SwipeableModals;
